<template>
  <section>
    <h2 class="sub-title">
      {{ Ranking.all[lang] }}
    </h2>
    <!-- 絞り込み -->
    <div class="narrow-down">
      <h3 class="h3-title">
        {{ Ranking.filter[lang] }}
        <span class="sub">
          {{ Ranking.multi[lang] }}
        </span>
      </h3>
      <dl
        class="narrow-down-list"
        v-for="(condition, index) in dataEventSummary.conditions"
        :key="index"
      >
        <dt class="narrow-down-list__team">
          <label for="refined-search-id" class="label">
            {{
              isCompany && condition.name == "居住地"
                ? "都道府県"
                : condition.name
            }}
          </label>
        </dt>
        <dd class="narrow-down-list__description">
          <select
            id="refined-search-id"
            class="select"
            :name="`${condition.param}`"
            v-model="$data['select' + condition.param]"
          >
            <option value="" selected>
              {{ Ranking.reserve[lang] }}
            </option>
            <option
              v-for="(group, index) in condition.groups"
              :key="index"
              :value="group.code"
            >
              {{ group.name }}
            </option>
          </select>
        </dd>
      </dl>
      <div class="narrow-down-search">
        <button
          type="button"
          @click="emitTypeNarrowingDown()"
          class="button filter flex-all-center"
        >
          <span>
            {{ Ranking.apply[lang] }}
          </span>
        </button>
      </div>
      <div class="narrow-down-search">
        <button type="button" @click="emitRanking()" class="button">
          {{ Ranking.clear[lang] }}
        </button>
      </div>
    </div>
  </section>
</template>

<script>
import Ranking from "../../../assets/constants/ranking/ranking.json";

export default {
  data() {
    return {
      selectgender: "",
      selectage: "",
      selectcountry: "",
      selectbranch: "",
      selectdepartment: "",
      selectaffiliation: "",
    };
  },
  methods: {
    /**
     * 旧イベント area=都道府県コード
     * 束ね area=99(日本) country=都道府県コード
     */
    emitTypeNarrowingDown: function () {
      this.$emit(
        "type-narrowing-down",
        this.selectgender,
        this.selectage,
        this.selectcountry,
        this.selectcountry,
        this.selectbranch,
        this.selectdepartment,
        this.selectaffiliation
      );
    },
    emitRanking: function () {
      // 絞り込み初期化
      this.selectbranch = "";
      this.selectdepartment = "";
      this.selectaffiliation = "";
      this.selectgender = "";
      this.selectage = "";
      this.selectcountry = "";
      this.$emit("initial-ranking");
    },
  },
  props: {
    dataEventSummary: Object,
    isCompany: Boolean,
  },
  computed: {
    Ranking: function () {
      return Ranking;
    },
    lang: function () {
      return this.$store.state.lang;
    },
  },
  name: "RefinedSearch",
};
</script>

<style scoped>
.narrow-down {
  margin: 25px 0 0 0;
  padding: 30px 25px 28px 25px;
  background-color: var(--defaultGrayColor);
  .h3-title {
    font-size: 24px;
    .sub {
      margin: 10px 0 0;
      font-size: 14px;
    }
  }
  .narrow-down-list {
    margin: 20px 0 0 0;
    &:first-of-type {
      margin: 30px 0 0 0;
    }
    &__team {
      line-height: 1;
      font-size: 20px;
      font-weight: bold;
      color: var(--defaultBlackColor);
    }
    &__description {
      margin: 10px 0 0 0;
      .select {
        padding: 0 22px 0 15px;
        width: 100%;
        height: 40px;
        border-radius: 6px;
        font-size: 16px;
        color: var(--defaultBlackColor);
        border: solid 1px var(--defaultBlackColor);
        background: var(--defaultWhiteColor)
          url("../../../assets/images/arrow-down.svg") no-repeat center right
          10px;
      }
    }
  }
  .narrow-down-search {
    margin: 20px 0 0 0;
    text-align: center;
    .button {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      width: 140px;
      height: 45px;
      border: solid 1px var(--defaultBlackColor);
      background-color: var(--defaultWhiteColor);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/sp/ranking/RefinedSearch.vue